import axios, { AxiosResponse } from 'axios';
import { EmailQuery, EmailReq, EmailRes } from '@src/types';

export const getEmails = (
  params?: EmailQuery
): Promise<AxiosResponse<EmailRes>> => {
  return axios.get(`emails/`, { params: { ...params, size: 20 } });
};

export const saveEmails = (
  data: EmailReq
): Promise<AxiosResponse<EmailReq>> => {
  return axios.post(`emails/`, data);
};

export const getEmailDetail = (
  templateId: number
): Promise<AxiosResponse<EmailReq>> => {
  return axios.get(`emails/${templateId}/`);
};

export const sendTestEmail = (
  templateId: number
): Promise<AxiosResponse<EmailReq>> => {
  return axios.post(`emails/test-template/`, { template_id: templateId });
};
